<template>
  <v-container fluid  class="pa-0 my-4">
    <v-card>
      <v-card-title class="grey lighten-4 py-0">
        <span class="title primary--text">Education</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" icon flat @click.native="addEducation" v-if="educationList.length !== 0">
          <v-icon>add</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0">
        <div v-if="educationList.length === 0" class="text-xs-center mt-2">
          <v-btn @click.native="addEducation" round color="primary">Add Education</v-btn>
        </div>
        <v-list v-else three-line>
        <template v-for="(educationEntity, index) in educationList">
          <v-list-tile avatar @click="">
            <v-list-tile-avatar>
              <v-icon>collections_bookmark</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                {{educationEntity.degree}}({{educationEntity.specialization}})
              </v-list-tile-title>
              <v-list-tile-sub-title>
                {{educationEntity.college}} &nbsp; (From: {{educationEntity.startDate}} &nbsp; To: {{educationEntity.endDate}})
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                {{educationEntity.description}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn color="primary" flat icon @click.native="editEducation(educationEntity)">
                <v-icon>edit</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 !== educationList.length"></v-divider>
        </template>
      </v-list>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dialogOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-menu v-model="deleteDialogOpen"
              :close-on-content-click="false" v-show="education.id !== null">
              <v-btn flat dark slot="activator">Delete</v-btn>
              <v-card>
                <v-card-title>
                  <span class="headline error--text">Delete Data</span>
                </v-card-title>
                <v-card-text>
                  Sure you want to delete this record?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" outline round @click.native="deleteDialogOpen = false">No</v-btn>
                  <v-btn color="error" round @click.native="deleteEducation" :loading="loading" :disabled="loading">Yes</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-btn dark flat @click.native="saveEducation" :loading="loading" :disabled="loading">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="educationForm">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field name="degree" label="Degree" value="Input text" :counter="64" v-model="education.degree" :rules="rules.degree" box required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field name="specialization" label="Specialization" :counter="128" value="Input text" v-model="education.specialization" :rules="rules.specialization" box required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-menu
                    ref="startDateMenu"
                    :close-on-content-click="false"
                    v-model="menu.startDate"
                    :return-value.sync="education.startDate"
                    lazy
                    transition="scale-transition"
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="education.startDate"
                      name="startDate"
                      label="From (YYYY-MM)"
                      value="Input text"
                      readonly
                      :rules="rules.isRequired"
                      box
                      required
                    ></v-text-field>
                    <v-date-picker
                      v-model="education.startDate"
                      :max="currentMonth"
                      type="month"
                      no-title
                      scrollable
                      @input="$refs.startDateMenu.save(education.startDate)"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-menu
                    ref="endDateMenu"
                    :close-on-content-click="false"
                    v-model="menu.endDate"
                    :return-value.sync="education.endDate"
                    lazy
                    transition="scale-transition"
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="education.endDate"
                      name="endDate"
                      label="To (YYYY-MM)"
                      value="Input text"
                      readonly
                      :rules="rules.isRequired"
                      box
                      required
                    ></v-text-field>
                    <v-date-picker
                      v-model="education.endDate"
                      type="month"
                      :max="currentMonth"
                      no-title
                      scrollable
                      @input="$refs.endDateMenu.save(education.endDate)"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <small v-show="dateErrorStatus" class="error--text ml-2">
                    End Date cannot be earlier than Start Date
                  </small>
                </v-flex>
                <v-flex xs12>
                  <v-text-field name="college" label="Institute" :counter="64" value="Input text" v-model="education.college" :rules="rules.college" box required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea name="description" rows="2" :counter="2000" label="Description (optional)" value="Input text" v-model="education.description" placeholder="project summary, role, responsibilities etc" :rules="rules.description" box></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
export default {
  name: 'EducationCard',
  watch: {
    dialogOpen (value) {
      if (!value) {
        this.dateErrorStatus = false
      }
    }
  },
  data () {
    return {
      deleteDialogOpen: false,
      dateErrorStatus: false,
      todayDate: new Date(),
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ],
        degree: [
          (v) => !!v || 'Degree is required',
          (v) => (v && v.length <= 64) || 'Degree must be less than 64 characters'
        ],
        specialization: [
          (v) => !!v || 'Specialization is required',
          (v) => (v && v.length <= 128) || 'Specialization must be less than 128 characters'
        ],
        college: [
          (v) => !!v || 'College is required',
          (v) => (v && v.length <= 64) || 'College must be less than 64 characters'
        ],
        description: [
          (v) => (!v || v.length <= 2000) || 'Description must be less than 2000 characters'
        ]
      },
      dialogOpen: false,
      menu: {
        startDate: false,
        endDate: false
      }
    }
  },
  created () {
    Store.dispatch('profile/getEducationList')
  },
  computed: {
    ...mapState('profile', {
      educationList: 'educationList',
      education: 'education',
      loading: 'loading'
    }),
    title () {
      if (this.education.id === null) return 'Add Education'
      else return 'Edit Education'
    },
    currentMonth () {
      let today = new Date()
      let currentYear = today.getFullYear() + '-' + Number(today.getMonth() + 1)
      return currentYear
    }
  },
  methods: {
    cb () {
      this.$refs.educationForm.reset()
      this.dialogOpen = false
      this.deleteDialogOpen = false
    },
    async deleteEducation () {
      await Store.dispatch('profile/deleteEducation', {id: this.education.id, cb: this.cb})
    },
    editEducation (education) {
      Store.dispatch('profile/updateEducationForm', { ...education })
      this.dialogOpen = true
    },
    addEducation () {
      Store.dispatch('profile/updateEducationForm', null)
      // this.cb()
      this.$refs.educationForm.reset()
      this.dialogOpen = true
    },
    async saveEducation () {
      var startDate = new Date(this.education.startDate)
      var endDate = new Date(this.education.endDate)
      if (startDate.getTime() > endDate.getTime()) {
        this.dateErrorStatus = true
        return false
      }
      if (this.$refs.educationForm.validate()) {
        const education = { ...this.education }
        await Store.dispatch('profile/saveEducation', {education, cb: this.cb})
        // this.cb()
        // this.dialogOpen = false
      }
    },
    cancelForm () {
      Store.dispatch('profile/updateEducationForm', null).then(this.cb)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EducationCard.vue